// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgCapsuleBed = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill={color}
    height={size}
  >
    <path d="M18 4a.75.75 0 0 1 0 1.5H7.25a4.5 4.5 0 0 0-4.208 6.094h5.227V8.889a.735.735 0 0 1 .743-.743h7.123a2.615 2.615 0 0 1 2.615 2.616V12.1a1 1 0 0 1-1 1H3.99c.82.861 1.977 1.4 3.26 1.4H18a.75.75 0 0 1 0 1.5H7.25a6 6 0 0 1 0-12H18Zm-8.245 7.594v-.02h-.05l.05.02Zm0-.02h7.509v-.833a1.13 1.13 0 0 0-1.13-1.129h-6.38v1.962ZM6.229 7.75a.991.991 0 1 1-.002 1.982.991.991 0 0 1 .002-1.982Z" />
  </svg>
)

export default SvgCapsuleBed
